<script setup lang="ts">
  import { inject, provide } from 'vue'
  import { tenantUserDetailKey } from '@gat-ship/types/injection-keys'
  import { useTenantUserDetail } from '../../composables/useTenantUserDetail'

  const props = defineProps<{
    // Consumed reactively inside useTenantUserDetail via the passed `props`
    // object (watch(() => props.tenantUserId)); the rule can't see it.
    // eslint-disable-next-line vue/no-unused-properties
    tenantUserId?: string
  }>()

  const dataSource =
    inject(tenantUserDetailKey, undefined) ?? useTenantUserDetail(props)
  provide(tenantUserDetailKey, dataSource)

  defineExpose(dataSource)
</script>

<template>
  <slot :tenant-user="dataSource.tenantUser.value" />
</template>
